import { GzDialogWebComponent } from '../../../ui/gzDialog';

export class DisableReservedSeatsOptionConfirmationWindow {
  public static showDisableReservedSeatsOptionConfirmationWindow(
    translateFn,
    cancelCallback?: null | EventListenerOrEventListenerObject,
    confirmCallback?: null | EventListenerOrEventListenerObject
  ) {
    const dialogBodyHtml = `
      <p>${translateFn(
        'By disabling the Reserved Seats option, you allow dynamic provisioning of license seats to this company and its clients.'
      )}</p>

    `;

    const dialogFooterHtml = `
      <gz-button id='confirm' type='outline' color='negative' class='mr-2'>
       ${translateFn('Disable')}
      </gz-button>
      <gz-button id='cancel' type='outline' color='secondary'>
        ${translateFn('Cancel')}
      </gz-button>
    `;

    const dialogTitle = translateFn('Disable reserved seats');

    GzDialogWebComponent.computeCustomDialog(
      dialogBodyHtml,
      dialogFooterHtml,
      dialogTitle,
      cancelCallback,
      confirmCallback
    );
  }
}
